import React from 'react';
import { TrainDetail } from '../../../../types/LTSTypes';
import { SearchedTrainsListProps } from './SearchedTrainsList.types';

const SearchedTrainsList = (props: SearchedTrainsListProps) => {
  const { trainList, onClick } = props;

  const handleOnClick = (trainDetail: TrainDetail) => {
    onClick(trainDetail);
  };

  return (
    <div className="LTSTrainNumber-SearchedTrainsList-wrapper">
      <ul className="LTSPageCommon-ul">
        {trainList.map((item, index) => (
          <li
            className="LTSPageCommon-li LTSTrainNumber-SearchedTrainsList-li LTSPageCommon-click-transition"
            key={`${item.xtr.tid}-${index}`}
            onClick={() => {
              handleOnClick({
                trainName: item.n,
                trainNumber: item.xtr.tid
              });
            }}
          >
            <span>{item.xtr.tid}</span>
            <span className="LTSPageCommon-text-overflow-ellipsis">{item.n}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SearchedTrainsList;
